module.exports = __webpack_public_path__ + "img/protagonistas.6af963f6.png";